// Villes et quartiers de Côte d'Ivoire — données enrichies (Abidjan 10 communes + Grand Abidjan + grandes villes)
export const VILLES_QUARTIERS_CI = {
  // --- District Autonome d'Abidjan (communes) ---
  "Abidjan - Cocody": [
    "Cocody Centre", "II Plateaux", "II Plateaux Vallon", "Angré", "Angré 7ème Tranche", "Angré 8ème Tranche",
    "Riviera 1", "Riviera 2", "Riviera 3", "Riviera 4", "Riviera Palmeraie", "Riviera Bonoumin",
    "Riviera Faya", "Riviera M'Badon", "Riviera Beach", "Riviera Attoban", "Danga", "Blockhauss",
    "Cocody Ambassades", "220 Logements", "Abatta", "M'Badon", "Cité des Arts", "Saint-Jean",
  ],
  "Abidjan - Yopougon": [
    "Yopougon Sicogi", "Yopougon Selmer", "Niangon Nord", "Niangon Sud", "Andokoi", "Toit Rouge",
    "Gesco", "Wassakara", "Ananeraie", "Maroc (Yopougon)", "Sideci", "Port-Bouët 2", "Koweït", "Banco",
  ],
  "Abidjan - Abobo": [
    "Abobo Gare", "Abobo Baoulé", "Anonkoua-Kouté", "Avocatier", "Sagbé", "N'Dotré", "PK18",
    "Akéikoi", "Clouetcha", "Dokui", "Plaque", "Anador", "Abobo Sud", "Abobo Nord", "Belleville (Abobo)",
  ],
  "Abidjan - Adjamé": [
    "Adjamé Centre", "Adjamé Liberté", "220 Logements (Adjamé)", "Bracodi", "Williamsville", "Mirador",
    "Bromakoté", "Zone Industrielle (Adjamé)", "Paillet", "Habitat (Adjamé)",
  ],
  "Abidjan - Attécoubé": [
    "Attécoubé Centre", "Locodjro", "Abattoir", "Boribana", "Sébroko", "Santé", "Mossikro", "Agban",
  ],
  "Abidjan - Koumassi": [
    "Koumassi Grand Marché", "Koumassi Remblais", "Sicogi Koumassi", "Prodomo", "Campement",
    "Zone Industrielle (Koumassi)", "Sopim", "Divo (Koumassi)",
  ],
  "Abidjan - Marcory": [
    "Marcory Résidentiel", "Marcory Anoumabo", "Biétry", "Zone 4", "Aliodan", "Sans-Fil", "Konankro",
  ],
  "Abidjan - Plateau": [
    "Plateau Centre", "Plateau Dokui", "Cité Administrative", "Quartier des Affaires", "Plateau Indénié",
  ],
  "Abidjan - Port-Bouët": [
    "Port-Bouët Centre", "Vridi", "Gonzagueville", "Aéroport", "Adjouffou", "Jean-Folly", "Anani", "Vridi Cité",
  ],
  "Abidjan - Treichville": [
    "Treichville Centre", "Arras", "Belleville (Treichville)", "Avenue 16", "Biafra", "Zone Portuaire", "Notre-Dame",
  ],
  "Abidjan - Bingerville": [
    "Bingerville Centre", "Abatta", "Adjín", "Akandjé", "Akoyaté", "Bregbo", "Cité CIE", "Cité Marina",
    "Eloka", "Gbagba", "Mitterrand", "Paris-Village", "Riviera 6", "Carrière", "Blanchon",
  ],
  "Abidjan - Songon": ["Songon Agban", "Songon Kassemblé", "Songon Té", "Songon Dagbé", "M'Badon (Songon)"],
  "Abidjan - Anyama": ["Anyama Centre", "Anyama Adjamé", "Ebimpé", "Zossonkoi", "Anyama Débarcadère"],

  // --- Grand Abidjan (stations balnéaires) ---
  "Grand-Bassam": [
    "Quartier France", "Impérial", "Moossou", "Mockeyville", "Mondoukou", "Petit-Paris", "Quartier Phare",
    "Village N'zima", "Abrobakro", "Aboikro", "Abdoulayékro", "Azuretti", "Assoyam",
  ],
  "Assinie": [
    "Assinie-Mafia", "Assinie-France", "Assinie-Sagbadou", "Assouindé", "Ebotiam", "Essankro",
    "Mabianéha", "Mandjian",
  ],

  // --- Grandes villes de l'intérieur ---
  "Bouaké": [
    "Commerce", "Nimbo", "Houphouëtville", "Air France 1", "Air France 2", "Air France 3", "Belleville (Bouaké)",
    "Dar-ès-Salam", "Koko (Bouaké)", "N'Gattakro", "N'Dakonankro", "Gonfreville", "Kennedy (Bouaké)",
    "Maroc (Bouaké)", "Broukro", "Tolla", "Zone Industrielle (Bouaké)", "Sokoura",
  ],
  "Yamoussoukro": [
    "Assabou", "Habitat", "Kokrenou", "Millionnaire (Abla Pokou)", "Morofé", "N'Zuessy", "Nanan",
    "Présidence", "Riviera (Yakro)", "Sinzibo", "Sopim", "Belleville (Yakro)", "Dioulakro", "Kpangbassou",
    "Quartier Énergie", "Quartier Thérèse", "220 Logements (Yakro)", "100 Logements",
  ],
  "Korhogo": [
    "Koko (Naguinkaha)", "Soba", "Air-France (Korhogo)", "Petit Paris", "Dem", "Quartier 14",
    "Résidentiel (Korhogo)", "Banaforo", "Tchélékémogo",
  ],
  "Man": [
    "Koko (Man)", "Air France A", "Air France B", "Babadjan", "Belleville (Man)", "Dioulabougou (Man)",
    "Gbêpleu", "Glongouin", "Kennedy (Man)", "Libreville (Man)", "Maroc (Man)", "Quartier Résidentiel",
    "Soleil", "Tampleu", "Terre Rouge", "Zélé", "Centre-ville (Man)",
  ],
  "Abengourou": ["Centre-ville (Abengourou)", "Zongo", "Amélékia", "Dioulakro (Abengourou)", "EECI", "Agnikro"],
};

export const AUTRE_QUARTIER = "Autre quartier (préciser)";

// Option de secours pour ne jamais bloquer un utilisateur
Object.keys(VILLES_QUARTIERS_CI).forEach((ville) => {
  VILLES_QUARTIERS_CI[ville].push(AUTRE_QUARTIER);
});

export const COMMUNES_ABIDJAN = Object.keys(VILLES_QUARTIERS_CI).filter((v) => v.startsWith("Abidjan - "));
export const VILLES_INTERIEUR = Object.keys(VILLES_QUARTIERS_CI).filter((v) => !v.startsWith("Abidjan - "));

// Ville principale pour les filtres (les communes d'Abidjan → "Abidjan")
export const villePrincipale = (ville) => (ville?.startsWith("Abidjan - ") ? "Abidjan" : ville);
